import { History, PenSquare } from "lucide-react";
import { clsxMerge } from "shared/lib/helpers";
import { AccountDetailsTabButton } from "shared/ui/account-details/base/button";

import { EMAIL_TEMPLATES_TABS } from "@/modules/email-templates-sidebar/constants";
import { useEmailTemplatesContext } from "@/modules/email-templates-sidebar/context";
import { PropsWithClassNameI } from "shared/lib/interfaces/ui";
import { FC } from "react";
import { Divider } from "@/modules/email-templates-sidebar/shared/divider";

const EMAIL_TEMPLATES_NAV_ITEMS = [
  {
    id: EMAIL_TEMPLATES_TABS.COMPOSE,
    text: "Compose",
    icon: <PenSquare className="w-4" />,
  },
  {
    id: EMAIL_TEMPLATES_TABS.HISTORY,
    text: "History",
    icon: <History className="w-4" />,
  },
];

export const EmailTemplatesSidebarTabs: FC<PropsWithClassNameI> = ({
  className,
}) => {
  const { activeTab, setActiveTab } = useEmailTemplatesContext();

  return (
    <div className={clsxMerge("bg-white px-5", className)}>
      <div className="flex w-full items-center pb-3">
        {EMAIL_TEMPLATES_NAV_ITEMS.map((item, i) => (
          <AccountDetailsTabButton
            key={i}
            className="mr-2"
            isActive={activeTab === item.id}
            onClick={() => setActiveTab(item.id)}
          >
            {item.icon}
            {item.text}
          </AccountDetailsTabButton>
        ))}
      </div>
      <Divider />
    </div>
  );
};
